var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-header grid grid__base" }, [
    _c("aside", { staticClass: "main-header--top" }, [
      _c("div", { staticClass: "main-header--container grid--container" }, [
        _c("div", { staticClass: "main-header--top-row grid--row" }, [
          _c(
            "div",
            { staticClass: "main-header--metanav grid--col" },
            [_c("meta-navigation", { attrs: { children: _vm.meta.items } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-header--languages grid--col" },
            [
              _c("language-menu", {
                attrs: { children: _vm.language.children }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("header", { staticClass: "main-header--bottom" }, [
      _c("div", { staticClass: "main-header--container grid--container" }, [
        _c("div", { staticClass: "main-header--bottom-row grid--row" }, [
          _c(
            "div",
            { staticClass: "main-header--logo grid--col" },
            [_c("app-logo", _vm._b({}, "app-logo", _vm.home.content, false))],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-header--menu grid--col" },
            [_c("main-menu", { attrs: { children: _vm.menu.items } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-header--hamburger" },
            [_c("hamburger")],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-404ba41c", { render: render, staticRenderFns: staticRenderFns })
  }
}